import { MenuItem } from '@affine/component';
import { IsFavoriteIcon } from '@affine/core/components/pure/icons';
import { CompatibleFavoriteItemsAdapter } from '@affine/core/modules/favorite';
import { useI18n } from '@affine/i18n';
import { ShareIcon } from '@blocksuite/icons/rc';
import { useLiveData, useService } from '@toeverything/infra';
import { useMemo } from 'react';

export const ConfigureFolderMenuItem = ({
  onConfigure,
}: {
  onConfigure: () => void;
}) => {
  const t = useI18n();

  return (
    <MenuItem
      prefixIcon={<ShareIcon />}
      onClick={onConfigure}
      data-testid="folder-menu-configure"
    >
      {t['com.streamlain.share-menu.shareButton']()}
    </MenuItem>
  );
};

export const FavoriteFolderOperation = ({ id }: { id: string }) => {
  const t = useI18n();
  const compatibleFavoriteItemsAdapter = useService(
    CompatibleFavoriteItemsAdapter
  );

  const favorite = useLiveData(
    useMemo(() => {
      return compatibleFavoriteItemsAdapter.isFavorite$(id, 'folder');
    }, [compatibleFavoriteItemsAdapter, id])
  );

  return (
    <MenuItem
      prefixIcon={<IsFavoriteIcon favorite={favorite} />}
      onClick={() => compatibleFavoriteItemsAdapter.toggle(id, 'folder')}
    >
      {favorite
        ? t['com.streamlain.rootAppSidebar.organize.folder-rm-favorite']()
        : t['com.streamlain.rootAppSidebar.organize.folder-add-favorite']()}
    </MenuItem>
  );
};
